import React, { memo, useMemo, useState } from 'react';
import Money from '../../../helpers/utils/money/money';
import Checks, { ChecksGroup } from '../../bootstrap/forms/Checks';
import FormGroup from '../../bootstrap/forms/FormGroup';
import Input from '../../bootstrap/forms/Input';

function ProductItem({ product, onChange, checked, showStatus }) {
  return (
    <div className='row g-3 py-2'>
      <div className='col-md-1'>
        <div className='h-100 d-flex align-items-center justify-content-center'>
          <ChecksGroup>
            <Checks
              type='switch'
              id={`product_${product.id}`}
              name='products'
              value={product.id}
              onChange={onChange}
              checked={checked}
              isInline
            />
          </ChecksGroup>
        </div>
      </div>
      <div className='col-md-1'>
        <img
          src={product.image_url}
          alt='Img'
          width={40}
          height={40}
        />
      </div>
      <div className='col-md-8'>
        <FormGroup>
          <Input value={product.name} disabled readOnly />
          {showStatus && (
            <small className={product.active ? 'text-success' : 'text-muted'}>
              {product.active ? 'Ativo' : 'Inativo'}
            </small>
          )}
        </FormGroup>
      </div>
      <div className='col-md-2'>
        <FormGroup>
          <Input
            value={Money.centsToMaskMoney(product.price)}
            disabled
            readOnly
          />
        </FormGroup>
      </div>
    </div>
  );
}

const ProductElement = memo(ProductItem);

function ListProducts({ hidden, products, productsSelected, onChange, showStatus = false }) {
  const [productSearch, setProductSearch] = useState('');

  const allSelected = useMemo(() => {
    return products.length > 0 && products.every(product => productsSelected.includes(product.id));
  }, [products, productsSelected]);

  const filteredProducts = useMemo(() => {
    const search = productSearch.trim().toLowerCase();

    if (!search) return products;

    return products.filter((product) =>
      product.name?.toLowerCase().includes(search)
    );
  }, [products, productSearch]);

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    const newSelected = checked ? products.map(product => product.id) : [];
    onChange({
      target: {
        name: 'products',
        value: newSelected,
      },
    });
  };

  if (!productsSelected) return null;

  return (
    <div style={{ maxHeight: 300 }} className='overflow-y' hidden={hidden}>
      <div>
        <div className='row g-3 align-items-center mt-4 py-2 ms-2 me-2'>
          <div className='col-md-5'>
            <ChecksGroup>
              <Checks
                type='switch'
                id='selectAll'
                label='Selecionar todos os produtos'
                name='selectAll'
                onChange={handleSelectAll}
                checked={allSelected}
                isInline
              />
            </ChecksGroup>
          </div>
          <FormGroup className='col-md-7 mb-0'>
            <Input
              value={productSearch}
              onChange={(event) => setProductSearch(event.target.value)}
              placeholder='Buscar produto'
            />
          </FormGroup>
        </div>
        <div className='row g-4 py-2'>
          <div className='col-md-1'>
            <p>#</p>
          </div>

          <div className='col-md-1'>
            <p>Imagem</p>
          </div>
          <div className='col-md-8'>
            <p>Produto</p>
          </div>
          <div className='col-md-2'>
            <p>Preço</p>
          </div>
        </div>
      </div>
      {filteredProducts.map((product) => (
        <ProductElement
          key={product.id}
          product={product}
          onChange={onChange}
          checked={productsSelected.includes(product.id)}
          showStatus={showStatus}
        />
      ))}
      {filteredProducts.length === 0 && (
        <div className='text-center text-muted py-3'>
          Nenhum produto encontrado
        </div>
      )}
    </div>
  );
}

export default memo(ListProducts);
